// Module
var code = "<form-dynamique nature=\"'multikeyvalue'\" field=\"$ctrl.elementsField\" model=\"$ctrl.entete.additionnalInfoMesure\" model-name=\"$ctrl.AdditionnalInfoMesure\" validation-disabled=\"true\" principal=\"true\" niveau-visibilite=\"undefined\"> </form-dynamique> ";
// Exports
module.exports = code;